export const filmImages = [
  {
    0: {
      name: "The Phantom Menace",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/7/75/EPI_TPM_poster.png/revision/latest/scale-to-width-down/300?cb=20130822171446",
    },
    1: {
      name: "Attack of the Clones",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/d/dd/Attack-Clones-Poster.jpg/revision/latest/scale-to-width-down/300?cb=20180318125654",
    },
    2: {
      name: "Revenge of the Sith",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/e/e7/EPIII_RotS_poster.png/revision/latest/scale-to-width-down/300?cb=20130822174232",
    },
    3: {
      name: "A New Hope",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/0/06/Star_Wars_Style_A_poster_1977.jpg/revision/latest/scale-to-width-down/300?cb=20100708051712",
    },
    4: {
      name: "The Empire Strikes Back",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/e/e4/Empire_strikes_back_old.jpg/revision/latest/scale-to-width-down/300?cb=20161114072554",
    },
    5: {
      name: "Return of the Jedi",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/b/b2/ReturnOfTheJediPoster1983.jpg/revision/latest/scale-to-width-down/300?cb=20170926193831",
    },
    6: {
      name: "The Force Awakens",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/f/fd/Star_Wars_Episode_VII_The_Force_Awakens.jpg/revision/latest/scale-to-width-down/300?cb=20151018162823",
    },
  },
];

export const planetImages = [
  {
    0: {
      name: "Tatooine",
      image:
        "https://vignette.wikia.nocookie.net/fr.starwars/images/f/f6/Tatoooinefull.jpg/revision/latest/scale-to-width-down/300?cb=20070206173843",
    },
    1: {
      name: "Alderaan",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/4/4a/Alderaan.jpg/revision/latest/scale-to-width-down/300?cb=20061211013805",
    },
    2: {
      name: "Yavin IV",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/d/d4/Yavin-4-SWCT.png/revision/latest/scale-to-width-down/300?cb=20170712005330",
    },
    3: {
      name: "Hoth",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/1/1d/Hoth_SWCT.png/revision/latest/scale-to-width-down/300?cb=20160630022322",
    },
    4: {
      name: "Dagobah",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/4/48/Dagobah_ep3.jpg/revision/latest/scale-to-width-down/300?cb=20100122163146",
    },
    5: {
      name: "Bespin",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/1/11/Bespin-SWCT.png/revision/latest/scale-to-width-down/300?cb=20170709211642",
    },
    6: {
      name: "Endor",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/1/1d/Endor_BF2.png/revision/latest/scale-to-width-down/300?cb=20171014232605",
    },
    7: {
      name: "Naboo",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/f/f0/Naboo_planet.png/revision/latest/scale-to-width-down/300?cb=20080723001712",
    },
    8: {
      name: "Coruscant",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/8/84/CoruscantGlobeE1.png/revision/latest/scale-to-width-down/300?cb=20130123002137",
    },
    9: {
      name: "Kamino",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/5/52/Kamino-DB.png/revision/latest/scale-to-width-down/300?cb=20150920190527",
    },
    10: {
      name: "Geonosis",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/3/34/DathomirJFO.jpg/revision/latest/scale-to-width-down/300?cb=20121231120327",
    },
    11: {
      name: "Utapau",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/c/ce/UtapauRotS.png/revision/latest/scale-to-width-down/300?cb=20160118063015",
    },
    12: {
      name: "Mustafar",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/a/af/Mustafar_DB.png/revision/latest/scale-to-width-down/300?cb=20160118061913",
    },
    13: {
      name: "Kashyyyk",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/d/d7/Corellia-SWCT.png/revision/latest/scale-to-width-down/300?cb=20140817213258",
    },
    14: {
      name: "Polis Massa",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/f/f0/DQar_SWCT.png/revision/latest/scale-to-width-down/300?cb=20151014200906",
    },
    15: {
      name: "Mygeeto",
      image:
        "https://vignette.wikia.nocookie.net/fr.starwars/images/e/ee/Mygeeto.jpg/revision/latest/scale-to-width-down/350?cb=20150312140158",
    },
    16: {
      name: "Felucia",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/a/a2/Felucia_SWCT.png/revision/latest/scale-to-width-down/300?cb=20170714021015",
    },
    17: {
      name: "Cato Neimoidia",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/c/c0/CatoNeimoidia-SS.png/revision/latest/scale-to-width-down/300?cb=20120830233305",
    },
    18: {
      name: "Saleucami",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/0/06/BraccaPlanet-JFO.jpg/revision/latest/scale-to-width-down/300?cb=20120903165734",
    },
    19: {
      name: "Stewjon",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/3/30/Devaron-SWFFfb.png/revision/latest/scale-to-width-down/300?cb=20150920045330",
    },
    20: {
      name: "Eriadu",
      image:
        "https://vignette.wikia.nocookie.net/fr.starwars/images/5/58/Eriadu.jpg/revision/latest/scale-to-width-down/300?cb=20150226101409",
    },
    21: {
      name: "Corellia",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/7/7f/Corellia_SOF.png/revision/latest/scale-to-width-down/300?cb=20170222012701",
    },
    22: {
      name: "Rodia",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/c/c3/Rodia_canon.png/revision/latest/scale-to-width-down/300?cb=20150817013106",
    },
    23: {
      name: "Nal Hutta",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/d/da/Cantonica_TLJVD.png/revision/latest/scale-to-width-down/300?cb=20130517035000",
    },
    24: {
      name: "Dantooine",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/a/a5/Dantooine_Resistance.jpg/revision/latest/scale-to-width-down/300?cb=20170627023617",
    },
    25: {
      name: "Bestine IV",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/7/79/Bestine_TEA.png/revision/latest/scale-to-width-down/300?cb=20180325210122",
    },
    26: {
      name: "Ord Mantell",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/3/36/Ord_Mantell_EotECR.png/revision/latest/scale-to-width-down/300?cb=20170222012958",
    },
    27: {
      name: "unknown",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/e/e9/Unkwld_space.jpg/revision/latest/scale-to-width-down/300?cb=20070111044756",
    },
    28: {
      name: "Trandosha",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/a/a0/Garel.png/revision/latest/scale-to-width-down/300?cb=20130530013144",
    },
    29: {
      name: "Socorro",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/1/16/Coruscant-EotE.jpg/revision/latest/scale-to-width-down/300?cb=20130908205521",
    },
    30: {
      name: "Mon Cala",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/2/24/Mon_Cala_SWCT.png/revision/latest/scale-to-width-down/300?cb=20170715000612",
    },
    31: {
      name: "Chandrila",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/9/9b/Chandrila_AoRCR.png/revision/latest/scale-to-width-down/300?cb=20170222012047",
    },
    32: {
      name: "Sullust",
      image:
        "https://vignette.wikia.nocookie.net/fr.starwars/images/9/91/Sullust.png/revision/latest/scale-to-width-down/300?cb=20180322102341",
    },
    33: {
      name: "Toydaria",
      image:
        "https://vignette.wikia.nocookie.net/fr.starwars/images/5/5c/Toydaria.png/revision/latest/scale-to-width-down/300?cb=20150608200945",
    },
    34: {
      name: "Malastare",
      image:
        "https://vignette.wikia.nocookie.net/fr.starwars/images/d/de/Malastare.jpg/revision/latest/scale-to-width-down/300?cb=20160906193320",
    },
    35: {
      name: "Dathomir",
      image:
        "https://vignette.wikia.nocookie.net/fr.starwars/images/d/d7/Dathomir.png/revision/latest/scale-to-width-down/300?cb=20150207080416",
    },
    36: {
      name: "Ryloth",
      image:
        "https://vignette.wikia.nocookie.net/fr.starwars/images/a/a9/Ryloth.png/revision/latest/scale-to-width-down/300?cb=20160405081127",
    },
    37: {
      name: "Aleen Minor",
      image:
        "https://vignette.wikia.nocookie.net/fr.starwars/images/4/42/Aleen.png/revision/latest/scale-to-width-down/300?cb=20150228091544",
    },
    38: {
      name: "Vulpter",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/3/30/Christophsis.jpg/revision/latest/scale-to-width-down/300?cb=20150623125011",
    },
    39: {
      name: "Troiken",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/6/6c/Arvala-7.png/revision/latest/scale-to-width-down/300?cb=20150920045330",
    },
    40: {
      name: "Tund",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/b/bf/BaraanFa.png/revision/latest/scale-to-width-down/300?cb=20161028084834",
    },
    41: {
      name: "Haruun Kal",
      image:
        "https://vignette.wikia.nocookie.net/fr.starwars/images/c/c8/Haruun_Kal.jpg/revision/latest/scale-to-width-down/300?cb=20130108050310",
    },
    42: {
      name: "Cerea",
      image:
        "https://vignette.wikia.nocookie.net/fr.starwars/images/0/01/Cerea.jpg/revision/latest/scale-to-width-down/300?cb=20150531081925",
    },
    43: {
      name: "Glee Anselm",
      image:
        "https://vignette.wikia.nocookie.net/fr.starwars/images/0/0d/Glee_Anselm.jpg/revision/latest/scale-to-width-down/300?cb=20150612075440",
    },
    44: {
      name: "Iridonia",
      image:
        "https://vignette.wikia.nocookie.net/fr.starwars/images/c/c5/Iridonia.jpg/revision/latest/scale-to-width-down/300?cb=20150614075656",
    },
    45: {
      name: "Tholoth",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/0/04/Ahch-To_TLJTVD.png/revision/latest/scale-to-width-down/300?cb=20150920045330",
    },
    46: {
      name: "Iktotch",
      image:
        "https://vignette.wikia.nocookie.net/fr.starwars/images/c/cc/Iktotch.png/revision/latest/scale-to-width-down/300?cb=20170818142544",
    },
    47: {
      name: "Quermia",
      image:
        "https://vignette.wikia.nocookie.net/fr.starwars/images/e/e1/Quermia.jpg/revision/latest/scale-to-width-down/300?cb=20150226102638",
    },
    48: {
      name: "Dorin",
      image:
        "https://vignette.wikia.nocookie.net/fr.starwars/images/2/21/Dorin.jpg/revision/latest/scale-to-width-down/300?cb=20150511120112",
    },
    49: {
      name: "Champala",
      image:
        "https://vignette.wikia.nocookie.net/fr.starwars/images/8/85/Champala.jpg/revision/latest/scale-to-width-down/300?cb=20150823143356",
    },
    50: {
      name: "Mirial",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/1/13/Crait_TLJVD.png/revision/latest/scale-to-width-down/300?cb=20150920045330",
    },
    51: {
      name: "Serenno",
      image:
        "https://vignette.wikia.nocookie.net/fr.starwars/images/f/f1/Serenno.png/revision/latest/scale-to-width-down/300?cb=20150621074242",
    },
    52: {
      name: "Concord Dawn",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/c/c4/Castilon_USWNE.jpg/revision/latest/scale-to-width-down/300?cb=20160128165049",
    },
    53: {
      name: "Zolan",
      image:
        "https://vignette.wikia.nocookie.net/fr.starwars/images/6/66/Zolan.jpg/revision/latest/scale-to-width-down/300?cb=20150306143705",
    },
    54: {
      name: "Ojom",
      image:
        "https://vignette.wikia.nocookie.net/fr.starwars/images/9/9f/Ojom.jpg/revision/latest/scale-to-width-down/300?cb=20150621070427",
    },
    55: {
      name: "Skako",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/3/38/Eadu-SWCT.png/revision/latest/scale-to-width-down/300?cb=20150920045330",
    },
    56: {
      name: "Muunilinst",
      image:
        "https://vignette.wikia.nocookie.net/fr.starwars/images/1/19/Muunilinst.jpg/revision/latest/scale-to-width-down/300?cb=20150207084922",
    },
    57: {
      name: "Shili",
      image:
        "https://vignette.wikia.nocookie.net/fr.starwars/images/6/65/Shili.jpg/revision/latest/scale-to-width-down/300?cb=20150220150519",
    },
    58: {
      name: "Kalee",
      image:
        "https://vignette.wikia.nocookie.net/fr.starwars/images/0/05/Kalee.jpg/revision/latest/scale-to-width-down/300?cb=20150619090628",
    },
    59: {
      name: "Umbara",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/a/ac/Atollon_DoR.png/revision/latest/scale-to-width-down/300?cb=20160109160356",
    },
    60: {
      name: "Jakku",
      image:
        "https://vignette.wikia.nocookie.net/fr.starwars/images/e/ef/Jakku.jpg/revision/latest/scale-to-width-down/300?cb=20160402082150",
    },
  },
];

export const starshipImages = [
  {
    0: {
      name: "CR90 corvette",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/4/47/Rebels-TantiveIVConceptArt-CroppedBackground.png/revision/latest/scale-to-width-down/300?cb=20150215073634",
    },
    1: {
      name: "Star Destroyer",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/5/58/ISD-I.png/revision/latest/scale-to-width-down/300?cb=20150416041211",
    },
    2: {
      name: "Sentinel-class landing craft",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/a/a7/TarkinLothalArrival.png/revision/latest/scale-to-width-down/300?cb=20150302012438",
    },
    3: {
      name: "Death Star",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/9/9d/DSI_hdapproach.png/revision/latest/scale-to-width-down/300?cb=20130221005853",
    },
    4: {
      name: "Millennium Falcon",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/2/21/MF_over_Takodana_SWCT.png/revision/latest/scale-to-width-down/300?cb=20170605041002",
    },
    5: {
      name: "Y-wing",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/1/1d/BTL-B_Y-wing_rear.jpg/revision/latest/scale-to-width-down/300?cb=20100128043202",
    },
    6: {
      name: "X-wing",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/5/56/X-wing_vs_TIE_fighter_on_Takodana.png/revision/latest/scale-to-width-down/300?cb=20160417062726",
    },
    7: {
      name: "TIE Advanced x1",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/1/1d/Vader_TIEAdvanced_SWB.png/revision/latest/scale-to-width-down/300?cb=20160915042032",
    },
    8: {
      name: "Executor",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/3/30/Executor_BF2.png/revision/latest/scale-to-width-down/300?cb=20140522233011",
    },
    9: {
      name: "Rebel transport",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/6/67/GR-75_Medium_Transport_TAEtrivia.png/revision/latest/scale-to-width-down/300?cb=20170627030525",
    },
    10: {
      name: "Slave 1",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/b/ba/Slave_I_DICE.png/revision/latest/scale-to-width-down/300?cb=20170825000729",
    },
    11: {
      name: "Imperial shuttle",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/a/af/Shuttle-CHRON.jpg/revision/latest/scale-to-width-down/300?cb=20100813150543",
    },
    12: {
      name: "EF76 Nebulon-B escort frigate",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/5/50/NBfrigate.JPG/revision/latest/scale-to-width-down/300?cb=20061215024715",
    },
    13: {
      name: "Calamari Cruiser",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/9/94/MCLiberty.jpg/revision/latest/scale-to-width-down/300?cb=20070104001953",
    },
    14: {
      name: "A-wing",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/8/8d/A-wing_DICE.png/revision/latest/scale-to-width-down/300?cb=20161021230115",
    },
    15: {
      name: "B-wing",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/7/71/BWingsKillISD2-ST.jpg/revision/latest/scale-to-width-down/300?cb=20151109015327",
    },
    16: {
      name: "Republic Cruiser",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/8/81/Radiant7_negvv.png/revision/latest/scale-to-width-down/300?cb=20170411231733",
    },
    17: {
      name: "Droid control ship",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/9/95/Lucrehulk_battleship_TCW.jpg/revision/latest/scale-to-width-down/300?cb=20090311015214",
    },
    18: {
      name: "Naboo fighter",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/d/d3/N-1_BF2.png/revision/latest/scale-to-width-down/300?cb=20170825000654",
    },
    19: {
      name: "Naboo Royal Starship",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/f/f2/NabooRoyalStarshipTatooine.png/revision/latest/scale-to-width-down/300?cb=20130121220216",
    },
    20: {
      name: "Scimitar",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/8/8b/Sith_Infiltrator_SWCT.png/revision/latest/scale-to-width-down/300?cb=20160629050027",
    },
    21: {
      name: "J-type diplomatic barge",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/7/76/Naboo_Royal_Cruiser_DB.png/revision/latest/scale-to-width-down/300?cb=20171111134725",
    },
    22: {
      name: "AA-9 Coruscant freighter",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/c/c7/Aa9coruscantfreighter.jpg/revision/latest/scale-to-width-down/300?cb=20091201131352",
    },
    23: {
      name: "Jedi starfighter",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/7/79/Jedi_Starfighter_EpII.png/revision/latest/scale-to-width-down/300?cb=20150722030412",
    },
    24: {
      name: "H-type Nubian yacht",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/1/1a/NabooYachtLanding-AotC.jpg/revision/latest/scale-to-width-down/300?cb=20111001150233",
    },
    25: {
      name: "Republic Assault ship",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/4/4b/Acclamator.jpg/revision/latest/scale-to-width-down/300?cb=20170302022437",
    },
    26: {
      name: "Solar Sailer",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/6/60/Solar_Sailer_Coruscant.jpg/revision/latest/scale-to-width-down/300?cb=20060527223214",
    },
    27: {
      name: "Trade Federation cruiser",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/4/47/InvisibleHandStarboard-FF.png/revision/latest/scale-to-width-down/300?cb=20160906045609",
    },
    28: {
      name: "Theta-class T-2c shuttle",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/8/8e/Theta-class_shuttle.png/revision/latest/scale-to-width-down/300?cb=20180412042447",
    },
    29: {
      name: "Republic attack cruiser",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/0/0d/Imperial_attack_cruisers.png/revision/latest/scale-to-width-down/300?cb=20140317112248",
    },
    30: {
      name: "Naboo star skiff",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/d/df/Naboo_star_skiff_1.png/revision/latest/scale-to-width-down/300?cb=20130212042348",
    },
    31: {
      name: "Jedi Interceptor",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/a/a6/Eta-2_Interceptor.png/revision/latest/scale-to-width-down/300?cb=20130613124413",
    },
    32: {
      name: "arc-170",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/b/ba/ARC170starfighter.jpg/revision/latest/scale-to-width-down/300?cb=20111112062600",
    },
    33: {
      name: "Banking clan frigate",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/0/07/Munificent_TCW.jpg/revision/latest/scale-to-width-down/300?cb=20090311013715",
    },
    34: {
      name: "Belbullab-22 starfighter",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/3/3e/Soulless_One2_TCW.jpg/revision/latest/scale-to-width-down/300?cb=20090311020627",
    },
    35: {
      name: "V-wing",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/a/a9/V-wing_BF2.png/revision/latest/scale-to-width-down/300?cb=20170825000555",
    },
    36: {
      name: "T-70 X-wing fighter",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/7/78/Episode_VII_-_X_wing_Squadron.png/revision/latest/scale-to-width-down/300?cb=20150914023437",
    },
  },
];

export const vehicleImages = [
  {
    0: {
      name: "Sand Crawler",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/f/ff/Sandcrawler.png/revision/latest/scale-to-width-down/300?cb=20130812001443",
    },
    1: {
      name: "T-16 skyhopper",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/f/f2/T-16_skyhopper_-_SW_20.png/revision/latest/scale-to-width-down/300?cb=20160805002611",
    },
    2: {
      name: "X-34 landspeeder",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/5/54/X34-landspeeder.jpg/revision/latest/scale-to-width-down/300?cb=20080316031428",
    },
    3: {
      name: "TIE/LN starfighter",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/9/92/TIEfighter2-Fathead.png/revision/latest/scale-to-width-down/300?cb=20161109040841",
    },
    4: {
      name: "Snowspeeder",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/4/44/T-47_Speeder_DICE.png/revision/latest/scale-to-width-down/300?cb=20151106063152",
    },
    5: {
      name: "TIE bomber",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/1/17/TIE_Bomber_BF2.png/revision/latest/scale-to-width-down/300?cb=20170825000703",
    },
    6: {
      name: "AT-AT",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/1/16/AT-AT_2_Fathead.png/revision/latest/scale-to-width-down/300?cb=20161108042721",
    },
    7: {
      name: "AT-ST",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/f/ff/ATST-SWBdice.png/revision/latest/scale-to-width-down/300?cb=20151110032640",
    },
    8: {
      name: "Storm IV Twin-Pod cloud car",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/3/3b/Cloud-car-v2.png/revision/latest/scale-to-width-down/300?cb=20160617064429",
    },
    9: {
      name: "Sail barge",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/8/8c/Sail_Barge.png/revision/latest/scale-to-width-down/300?cb=20130331043828",
    },
    10: {
      name: "Bantha-II cargo skiff",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/c/cc/Bantha-II_Cargo_Skiff_BG.png/revision/latest/scale-to-width-down/300?cb=20161023211218",
    },
    11: {
      name: "TIE/IN interceptor",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/f/f5/TIE_Interceptor_BF.png/revision/latest/scale-to-width-down/300?cb=20170501054325",
    },
    12: {
      name: "Imperial Speeder Bike",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/4/47/Speeder_Bike_DICE.png/revision/latest/scale-to-width-down/300?cb=20171102044625",
    },
    13: {
      name: "Vulture Droid",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/4/40/Droid_Starfighters.png/revision/latest/scale-to-width-down/300?cb=20130924231621",
    },
    14: {
      name: "Multi-Troop Transport",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/f/f5/MTTopenforbusiness-SWE.jpg/revision/latest/scale-to-width-down/300?cb=20120206202824",
    },
    15: {
      name: "Armored Assault Tank",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/7/78/SepAAT.jpg/revision/latest/scale-to-width-down/300?cb=20090311014604",
    },
    16: {
      name: "Single Trooper Aerial Platform",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/c/ce/STAP-SWE.png/revision/latest/scale-to-width-down/300?cb=20160914004451",
    },
    17: {
      name: "C-9979 landing craft",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/f/f0/C9979_ep1ig.jpg/revision/latest/scale-to-width-down/300?cb=20120226042037",
    },
    18: {
      name: "Tribubble bongo",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/d/d8/Bongo.jpg/revision/latest/scale-to-width-down/300?cb=20080430201913",
    },
    19: {
      name: "Sith speeder",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/c/c1/FC-20_Speeder.png/revision/latest/scale-to-width-down/300?cb=20151027005050",
    },
    20: {
      name: "Zephyr-G swoop bike",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/9/98/Zephyr-G.jpg/revision/latest/scale-to-width-down/300?cb=20051217192222",
    },
    21: {
      name: "Koro-2 Exodrive airspeeder",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/2/22/Koro2_uvg.jpg/revision/latest/scale-to-width-down/300?cb=20130519005132",
    },
    22: {
      name: "XJ-6 airspeeder",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/f/f6/XJ-6_hotrod.jpg/revision/latest/scale-to-width-down/300?cb=20080218042929",
    },
    23: {
      name: "LAAT/i",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/c/c5/Low_Altitude_Assault_Transport.png/revision/latest/scale-to-width-down/300?cb=20130719130715",
    },
    24: {
      name: "LAAT/c",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/7/7f/LAATc_Geonosis_1.jpg/revision/latest/scale-to-width-down/300?cb=20111001151025",
    },
    25: {
      name: "AT-TE",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/9/9a/AT-TE-front.png/revision/latest/scale-to-width-down/300?cb=20151026185157",
    },
    26: {
      name: "SPHA",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/2/2a/SPHA-T.JPG/revision/latest/scale-to-width-down/300?cb=20060515020703",
    },
    27: {
      name: "Flitknot speeder",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/7/76/FlitknotSpeeder.jpg/revision/latest/scale-to-width-down/300?cb=20071213133909",
    },
    28: {
      name: "Neimoidian shuttle",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/c/cf/Sheathipede_OS.jpg/revision/latest/scale-to-width-down/300?cb=20120211051954",
    },
    29: {
      name: "Geonosian starfighter",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/8/82/Nantex-class_fighters.png/revision/latest/scale-to-width-down/300?cb=20160117183706",
    },
    30: {
      name: "Tsmeu-6 personal wheel bike",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/2/2c/GrievWheelBike_wsmi.jpg/revision/latest/scale-to-width-down/300?cb=20071215145011",
    },
    31: {
      name: "Emergency Firespeeder",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/6/66/Fire_ship.jpg/revision/latest/scale-to-width-down/300?cb=20051220124720",
    },
    32: {
      name: "Droid tri-fighter",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/a/a0/DroidTrifighter-TCWs3BR2.png/revision/latest/scale-to-width-down/300?cb=20150308204046",
    },
    33: {
      name: "Oevvaor jet catamaran",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/0/03/Wookieeflyingcat2.png/revision/latest/scale-to-width-down/300?cb=20130202035458",
    },
    34: {
      name: "Raddaugh Gnasp fluttercraft",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/1/19/Catamaran.JPG/revision/latest/scale-to-width-down/300?cb=20071030194931",
    },
    35: {
      name: "Clone turbo tank",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/f/f7/JuggernautROTS.jpg/revision/latest/scale-to-width-down/300?cb=20091201162123",
    },
    36: {
      name: "Corporate Alliance tank droid",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/7/73/Tank_droid_TCW.png/revision/latest/scale-to-width-down/300?cb=20170703051940",
    },
    37: {
      name: "Droid gunship",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/6/6d/DroidGunship-DB.png/revision/latest/scale-to-width-down/300?cb=20141227052202",
    },
    38: {
      name: "AT-RT",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/5/5c/AT-RT_BF2.png/revision/latest/scale-to-width-down/300?cb=20170825000646",
    },
  },
];

export const speciesImages = [
  {
    0: {
      name: "Human",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/d/d6/Human_NEGAS.jpg/revision/latest/scale-to-width-down/300?cb=20090709062312",
    },
    1: {
      name: "Droid",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/b/b6/2-1B_negtd.jpg/revision/latest/scale-to-width-down/300?cb=20100616170941",
    },
    2: {
      name: "Wookiee",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/1/14/Wookiee_NEGAS.jpg/revision/latest/scale-to-width-down/499?cb=20090711201859",
    },
    3: {
      name: "Rodian",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/2/23/Rodian_NEGAS.jpg/revision/latest/scale-to-width-down/300?cb=20061127015745",
    },
    4: {
      name: "Hutt",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/a/a7/HuttNEGAS.png/revision/latest/scale-to-width-down/300?cb=20130115030417",
    },
    5: {
      name: `Yoda's species`,
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/5/5a/YodaNEGAS.jpg/revision/latest/scale-to-width-down/300?cb=20061129202540",
    },
    6: {
      name: "Trandoshan",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/4/45/Trandoshan_NEGAS.png/revision/latest/scale-to-width-down/300?cb=20130115031110",
    },
    7: {
      name: "Mon Calamari",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/7/77/Mon_Calamari_NEGAS.jpg/revision/latest/scale-to-width-down/300?cb=20170926052257",
    },
    8: {
      name: "Ewok",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/8/82/EwokNEGAS.jpg/revision/latest/scale-to-width-down/499?cb=20061126065723",
    },
    9: {
      name: "Sullustan",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/f/f5/Sullustan_NEGAS.jpg/revision/latest/scale-to-width-down/499?cb=20100810063353",
    },
    10: {
      name: "Neimodian",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/5/52/Neimoidian_NEGAS.jpg/revision/latest/scale-to-width-down/300?cb=20061021200803",
    },
    11: {
      name: "Gungan",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/3/31/Gungan_NEGAS.jpg/revision/latest/scale-to-width-down/300?cb=20070225162243",
    },
    12: {
      name: "Toydarian",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/9/9a/Toydarian_EtU.png/revision/latest/scale-to-width-down/300?cb=20160920122918",
    },
    13: {
      name: "Dug",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/b/bd/Dug_NEGAS.jpg/revision/latest/scale-to-width-down/499?cb=20090709061842",
    },
    14: {
      name: `Twi'lek`,
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/9/95/TwilekNEGAS.png/revision/latest/scale-to-width-down/300?cb=20150523023715",
    },
    15: {
      name: "Aleena",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/e/e3/Ratts.jpg/revision/latest/scale-to-width-down/300?cb=20080508150745",
    },
    16: {
      name: "Vulptereen",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/c/cd/Dud_Bolt_FF_Scan.png/revision/latest/scale-to-width-down/300?cb=20150414170315",
    },
    17: {
      name: "Xexto",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/3/30/Gasgano.jpg/revision/latest/scale-to-width-down/300?cb=20150331133737",
    },
    18: {
      name: "Toong",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/1/18/BenQuadinarosFull-SWE.png/revision/latest/scale-to-width-down/300?cb=20160910192602",
    },
    19: {
      name: "Cerean",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/a/ae/Cerean_NEGAS.jpg/revision/latest/scale-to-width-down/300?cb=20100615162146",
    },
    20: {
      name: "Nautolan",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/4/4c/Nautolan_NEGAS.jpg/revision/latest/scale-to-width-down/300?cb=20061205192252",
    },
    21: {
      name: "Zabrak",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/e/ee/ZabrakNEGAS.jpg/revision/latest/scale-to-width-down/300?cb=20070416170907",
    },
    22: {
      name: "Tholothian",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/1/1a/Gallia.jpg/revision/latest/scale-to-width-down/300?cb=20060204153348",
    },
    23: {
      name: "Iktotchi",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/f/f0/Iktotchi_NEGAS.jpg/revision/latest/scale-to-width-down/300?cb=20061202133616",
    },
    24: {
      name: "Quermian",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/9/9a/XextoQuermian.jpg/revision/latest/scale-to-width-down/300?cb=20100810190143",
    },
    25: {
      name: "Kel Dor",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/2/24/Kel_Dor_NEGAS.jpg/revision/latest/scale-to-width-down/300?cb=20061130130943",
    },
    26: {
      name: "Chagrian",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/5/5e/ChagrianNEGAS.jpg/revision/latest/scale-to-width-down/499?cb=20061201134120",
    },
    27: {
      name: "Geonosian",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/a/a0/Geonosian_NEGAS.png/revision/latest/scale-to-width-down/300?cb=20170226060952",
    },
    28: {
      name: "Mirialan",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/2/2a/Mira.png/revision/latest/scale-to-width-down/300?cb=20150801192217",
    },
    29: {
      name: "Clawdite",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/3/37/ClawditeNEGAS.jpg/revision/latest/scale-to-width-down/300?cb=20090709061818",
    },
    30: {
      name: "Besalisk",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/1/1b/BesaliskNEGAS.jpg/revision/latest/scale-to-width-down/300?cb=20130908201429",
    },
    31: {
      name: "Kaminoan",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/0/03/KaminoanNEGAS.jpg/revision/latest/scale-to-width-down/499?cb=20090709062442",
    },
    32: {
      name: "Skakoan",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/a/a0/Skakoan2.jpg/revision/latest/scale-to-width-down/300?cb=20091012195839",
    },
    33: {
      name: "Muun",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/2/2c/Muun_FDEV_Arden_Beckwith.png/revision/latest/scale-to-width-down/300?cb=20180323003122",
    },
    34: {
      name: "Togruta",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/b/b2/Togruta_NEGAS.jpg/revision/latest/scale-to-width-down/300?cb=20100810070146",
    },
    35: {
      name: "Kaleesh",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/1/14/Kaleesh_NEGAS.jpg/revision/latest/scale-to-width-down/300?cb=20061205191444",
    },
    36: {
      name: `Pau'an`,
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/2/22/Pau%27an.jpg/revision/latest/scale-to-width-down/499?cb=20070705042952",
    },
  },
];

export const peopleImages = [
  {
    0: {
      name: "Luke Skywalker",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/d/d9/Luke-rotjpromo.jpg/revision/latest/scale-to-width-down/300?cb=20091030151422",
    },
    1: {
      name: "C-3PO",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/5/51/C-3PO_EP3.png/revision/latest/scale-to-width-down/300?cb=20131005124036",
    },
    2: {
      name: "R2-D2",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/1/1a/R2d2.jpg/revision/latest/scale-to-width-down/300?cb=20090524204255",
    },
    3: {
      name: "Darth Vader",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/9/94/Vaderrotj.jpg/revision/latest/scale-to-width-down/300?cb=20070418231644",
    },
    4: {
      name: "Leia Organa",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/8/89/Leia_endorpromo02.jpg/revision/latest/scale-to-width-down/300?cb=20080506155343",
    },
    5: {
      name: "Owen Lars",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/9/91/OwenLarsHS-SWE.jpg/revision/latest/scale-to-width-down/300?cb=20120428164235",
    },
    6: {
      name: "Beru Whitesun lars",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/7/76/Beru_headshot2.jpg/revision/latest/scale-to-width-down/300?cb=20111029215429",
    },
    7: {
      name: "R5-D4",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/2/2c/R5d4.jpg/revision/latest/scale-to-width-down/300?cb=20080404200713",
    },
    8: {
      name: "Biggs Darklighter",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/0/00/BiggsHS-ANH.png/revision/latest/scale-to-width-down/300?cb=20130305010406",
    },
    9: {
      name: "Obi-Wan Kenobi",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/e/e6/OWK_SWFB.png/revision/latest/scale-to-width-down/300?cb=20160910183426",
    },
    10: {
      name: "Anakin Skywalker",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/6/6f/Anakin_Skywalker_RotS.png/revision/latest/scale-to-width-down/300?cb=20130621175844",
    },
    11: {
      name: "Wilhuff Tarkin",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/c/c1/Tarkininfobox.jpg/revision/latest/scale-to-width-down/300?cb=20100620213033",
    },
    12: {
      name: "Chewbacca",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/e/ec/ChewbaccaCSWE.jpg/revision/latest/scale-to-width-down/300?cb=20130702064257",
    },
    13: {
      name: "Han Solo",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/0/01/Hansoloprofile.jpg/revision/latest/scale-to-width-down/499?cb=20100129155042",
    },
    14: {
      name: "Greedo",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/c/c6/Greedo.jpg/revision/latest/scale-to-width-down/300?cb=20180209034210",
    },
    15: {
      name: "Jabba Desilijic Tiure",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/7/7f/Jabba_SWSB.png/revision/latest/scale-to-width-down/300?cb=20160910034237",
    },
    16: {
      name: "Wedge Antilles",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/6/60/WedgeHelmetless-ROTJHD.jpg/revision/latest/scale-to-width-down/300?cb=20110916160227",
    },
    17: {
      name: "Jek Tono Porkins",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/5/53/Porkins.jpg/revision/latest/scale-to-width-down/300?cb=20111104223725",
    },
    18: {
      name: "Yoda",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/d/d6/Yoda_SWSB.png/revision/latest/scale-to-width-down/300?cb=20150206140125",
    },
    19: {
      name: "Palpatine",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/d/d8/Emperor_Sidious.png/revision/latest/scale-to-width-down/300?cb=20130620100935",
    },
    20: {
      name: "Boba Fett",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/5/58/BobaFettMain2.jpg/revision/latest/scale-to-width-down/300?cb=20130920001614",
    },
    21: {
      name: "IG-88",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/a/aa/IG-88B-ESB.jpg/revision/latest/scale-to-width-down/499?cb=20151130035541",
    },
    22: {
      name: "Bossk",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/1/1d/Bossk.png/revision/latest/scale-to-width-down/300?cb=20130219044712",
    },
    23: {
      name: "Lando Calrissian",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/7/7d/Lando_WoSW.jpg/revision/latest/scale-to-width-down/300?cb=20080715214753",
    },
    24: {
      name: "Lobot",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/e/e0/Lobot_SWSB.png/revision/latest/scale-to-width-down/300?cb=20160910032142",
    },
    25: {
      name: "Ackbar",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/f/fb/Ackbar_HS.jpg/revision/latest/scale-to-width-down/300?cb=20081118162020",
    },
    26: {
      name: "Mon Mothma",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/4/46/Monmothma.jpg/revision/latest/scale-to-width-down/300?cb=20070615234013",
    },
    27: {
      name: "Arvel Crynyd",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/d/de/Arvel-crynyd.jpg/revision/latest/scale-to-width-down/295?cb=20120113223349",
    },
    28: {
      name: "Wicket Systri Warrick",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/4/4f/Wicket_RotJ.png/revision/latest/scale-to-width-down/300?cb=20130622101905",
    },
    29: {
      name: "Nien Nunb",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/c/c7/NienNunbHS-SWE.jpg/revision/latest/scale-to-width-down/499?cb=20111120232928",
    },
    30: {
      name: "Qui-Gon Jinn",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/6/66/Qui-Gon_Jinn_SWFB.png/revision/latest/scale-to-width-down/300?cb=20160910051518",
    },
    31: {
      name: "Nute Gunray",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/f/fe/Nutegunraypromo_copy.jpg/revision/latest/scale-to-width-down/300?cb=20090417195344",
    },
    32: {
      name: "Finis Valorum",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/8/89/Valorum.jpg/revision/latest/scale-to-width-down/300?cb=20080801152355",
    },
    33: {
      name: "Padmé Amidala",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/b/b2/Padmegreenscrshot.jpg/revision/latest/scale-to-width-down/300?cb=20100423143631",
    },
    34: {
      name: "Jar Jar Binks",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/0/02/Jar_Jar_SWSB.png/revision/latest/scale-to-width-down/300?cb=20160910034613",
    },
    35: {
      name: "Roos Tarpals",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/c/ca/TarpalsHS.jpg/revision/latest/scale-to-width-down/300?cb=20180218034913",
    },
    36: {
      name: "Rugor Nass",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/d/d8/Bossnass.jpg/revision/latest/scale-to-width-down/300?cb=20171019170439",
    },
    37: {
      name: "Ric Olié",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/4/4c/RicOlieHS-SWE.png/revision/latest/scale-to-width-down/300?cb=20120226230538",
    },
    38: {
      name: "Watto",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/e/eb/WattoHS.jpg/revision/latest/scale-to-width-down/300?cb=20081222024729",
    },
    39: {
      name: "Sebulba",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/f/f4/Sebulba-SWISE2010.jpg/revision/latest/scale-to-width-down/300?cb=20110306033904",
    },
    40: {
      name: "Quarsh Panaka",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/0/0e/Moff_Panaka.jpg/revision/latest/scale-to-width-down/300?cb=20141130193801",
    },
    41: {
      name: "Shmi Skywalker",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/1/17/Shmi_FF.png/revision/latest/scale-to-width-down/300?cb=20160907060834",
    },
    42: {
      name: "Darth Maul",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/5/50/Darth_Maul_profile.png/revision/latest/scale-to-width-down/499?cb=20140209162228",
    },
    43: {
      name: "Bib Fortuna",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/3/33/BibFortunaHS-ROTJ.png/revision/latest/scale-to-width-down/295?cb=20130326042806",
    },
    44: {
      name: "Ayla Secura",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/f/f9/Aayla.jpg/revision/latest/scale-to-width-down/300?cb=20120815094201",
    },
    45: {
      name: "Ratts Tyerell",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/6/68/RattsHS.jpg/revision/latest/scale-to-width-down/300?cb=20111117040905",
    },
    46: {
      name: "Dud Bolt",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/b/b0/Dud_Bolt.jpg/revision/latest/scale-to-width-down/300?cb=20061130092516",
    },
    47: {
      name: "Gasgano",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/5/57/GasganoHS-SWE.jpg/revision/latest/scale-to-width-down/499?cb=20120112024006",
    },
    48: {
      name: "Ben Quadinaros",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/d/d5/Toong_AA.JPG/revision/latest/scale-to-width-down/300?cb=20070228212416",
    },
    49: {
      name: "Mace Windu",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/f/fc/Mace_Windu.jpg/revision/latest/scale-to-width-down/499?cb=20071230055326",
    },
    50: {
      name: "Ki-Adi-Mundi",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/9/9e/KiAdiMundi.jpg/revision/latest/scale-to-width-down/300?cb=20070930185700",
    },
    51: {
      name: "Kit Fisto",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/1/17/KitFisto-SithSnapshot.jpg/revision/latest/scale-to-width-down/499?cb=20051006220620",
    },
    52: {
      name: "Eeth Koth",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/b/b6/Eeth_Koth_profile.png/revision/latest/scale-to-width-down/300?cb=20131103213648",
    },
    53: {
      name: "Adi Gallia",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/b/ba/AdiGallia.jpg/revision/latest/scale-to-width-down/300?cb=20080126123820",
    },
    54: {
      name: "Saesee Tiin",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/c/ca/Iktotchi_AA.JPG/revision/latest/scale-to-width-down/300?cb=20071002144646",
    },
    55: {
      name: "Yarael Poof",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/9/96/Yarael_Poof.png/revision/latest/scale-to-width-down/300?cb=20131112121643",
    },
    56: {
      name: "Plo Koon",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/c/c4/Plo_Koon_TPM.png/revision/latest/scale-to-width-down/300?cb=20130911190623",
    },
    57: {
      name: "Mas Amedda",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/3/3f/Mas12432.jpg/revision/latest/scale-to-width-down/499?cb=20130913002346",
    },
    58: {
      name: "Gregar Typho",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/5/52/Gregar_Typho.jpg/revision/latest/scale-to-width-down/350?cb=20090903192036",
    },
    59: {
      name: "Cordé",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/d/de/Cord%C3%A9.jpg/revision/latest/scale-to-width-down/300?cb=20130225181527",
    },
    60: {
      name: "Cliegg Lars",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/3/36/ClieggLarsHS-SWE.jpg/revision/latest/scale-to-width-down/300?cb=20180513065414",
    },
    61: {
      name: "Poggle the Lesser",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/9/93/Poggle_the_lesser_-_sw_card_trader.png/revision/latest/scale-to-width-down/300?cb=20160707212132",
    },
    62: {
      name: "Luminara Unduli",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/2/21/LuminaraHS-SWE_%28new%29.png/revision/latest/scale-to-width-down/295?cb=20180206232118",
    },
    63: {
      name: "Barriss Offee",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/3/37/Barrisprofile2.jpg/revision/latest/scale-to-width-down/499?cb=20070728014608",
    },
    64: {
      name: "Dormé",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/1/18/Dormesenate.jpg/revision/latest/scale-to-width-down/300?cb=20070506233854",
    },
    65: {
      name: "Dooku",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/f/f1/Count_Dooku_headshot_gaze.jpg/revision/latest/scale-to-width-down/300?cb=20071218042012",
    },
    66: {
      name: "Bail Prestor Organa",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/5/50/Bail_Organa_Mug.jpg/revision/latest/scale-to-width-down/300?cb=20080823033853",
    },
    67: {
      name: "Jango Fett",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/7/70/Jango_OP.jpg/revision/latest/scale-to-width-down/300?cb=20071029210612",
    },
    68: {
      name: "Zam Wesell",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/d/d1/ZamWesell.jpg/revision/latest/scale-to-width-down/300?cb=20091224023343",
    },
    69: {
      name: "Dexter Jettster",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/6/6c/DexterHS-SWE.jpg/revision/latest/scale-to-width-down/300?cb=20111106014007",
    },
    70: {
      name: "Lama Su",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/7/73/Lama_Su.jpg/revision/latest/scale-to-width-down/499?cb=20080117165735",
    },
    71: {
      name: "Taun We",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/9/9c/TaunWe.jpg/revision/latest/scale-to-width-down/300?cb=20080117164920",
    },
    72: {
      name: "Jocasta Nu",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/4/44/Jocasta_Nu.jpg/revision/latest/scale-to-width-down/499?cb=20090909121527",
    },
    73: {
      name: "R4-P17",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/6/6b/R4-P17.jpg/revision/latest/scale-to-width-down/295?cb=20080429155212",
    },
    74: {
      name: "Wat Tambor",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/e/e8/TamborBoomHeadshot.jpg/revision/latest/scale-to-width-down/300?cb=20090607210827",
    },
    75: {
      name: "San Hill",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/4/4f/San_hill.jpg/revision/latest/scale-to-width-down/300?cb=20071203213757",
    },
    76: {
      name: "Shaak Ti",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/4/44/Shaak_Ti_Big_Headshot.jpg/revision/latest/scale-to-width-down/300?cb=20130421193922",
    },
    77: {
      name: "Grievous",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/d/de/Grievoushead.jpg/revision/latest/scale-to-width-down/300?cb=20100630082056",
    },
    78: {
      name: "Tarfful",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/3/37/Tarfful_RotS.png/revision/latest/scale-to-width-down/300?cb=20140825183910",
    },
    79: {
      name: "Raymus Antilles",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/8/80/Raymus_card_trader.png/revision/latest/scale-to-width-down/300?cb=20170716200353",
    },
    80: {
      name: "Sly Moore",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/e/ec/SlyMooreIsWatchingYouPoop-OfficialPix.jpg/revision/latest/scale-to-width-down/300?cb=20130913002333",
    },
    81: {
      name: "Tion Medon",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/e/e8/TionMedonchron.jpg/revision/latest/scale-to-width-down/300?cb=20070120141520",
    },
    82: {
      name: "Finn",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/a/af/Finn_TLJ_Collector%27s_Edition.png/revision/latest/scale-to-width-down/300?cb=20180124021541",
    },
    83: {
      name: "Rey",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/f/f8/ReyTLJEntertainmentWeeklyNovember.png/revision/latest/scale-to-width-down/300?cb=20171119211748",
    },
    84: {
      name: "Poe Dameron",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/7/79/Poe_Dameron_TLJ.png/revision/latest/scale-to-width-down/300?cb=20180124021517",
    },
    85: {
      name: "BB8",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/6/68/BB8-Fathead.png/revision/latest/scale-to-width-down/300?cb=20161108050455",
    },
    86: {
      name: "Captain Phasma",
      image:
        "https://vignette.wikia.nocookie.net/starwars/images/0/02/Phasma.png/revision/latest/scale-to-width-down/300?cb=20171231052405",
    },
  },
];
